import React from 'react'

import SvgIcon from './SvgIcon.js'

export default () => (
  <SvgIcon>
    <polygon points="5,30.858 5,2.381 30.629,16.618 " />
  </SvgIcon>
)
